import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
import { ThankYou } from './components/ThankYou';
import { GoogleTagManager } from './components/GoogleTagManager';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ConsultationPage } from './components/ConsultationPage';
export function App() {
  const MainContent = () => <div className="font-sans text-black" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TestimonialsSection data-id="element-4" />
        <TrustBar data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
      <WhatsAppButton data-id="element-7" />
    </div>;
  // Redirect component that performs the redirect
  const MeetRedirect = () => {
    useEffect(() => {
      window.location.replace('https://teams.microsoft.com/meet/38930804206887?p=jiTX40nHg22NkUwgoC');
    }, []);
    return null;
  };
  return <>
      <GoogleTagManager data-id="element-8" />
      <BrowserRouter data-id="element-9">
        <Routes data-id="element-10">
          <Route path="/" element={<MainContent data-id="element-12" />} data-id="element-11" />
          <Route path="/thankyou" element={<ThankYou data-id="element-14" />} data-id="element-13" />
          <Route path="/meet" element={<MeetRedirect data-id="element-16" />} data-id="element-15" />
          <Route path="/consultation" element={<ConsultationPage data-id="element-18" />} data-id="element-17" />
        </Routes>
      </BrowserRouter>
    </>;
}